.root {
  position: var(--haus-usermenu__root__position, absolute);
  top: var(--haus-usermenu__root__top, 0);
  left: var(--haus-usermenu__root__left, 0);
  width: var(--haus-usermenu__root__width, 100%);
  height: var(--haus-usermenu__root__height, 100%);
  display: var(--haus-usermenu__root__display, block);
  pointer-events: var(--haus-usermenu__root__pointer-events, auto);
}

.trigger {
  all: unset;
  cursor: var(--haus-usermenu__trigger__cursor, pointer);
  width: var(--haus-usermenu__trigger__width, 100%);
  height: var(--haus-usermenu__trigger__height, 100%);
  display: var(--haus-usermenu__trigger__display, block);
  position: var(--haus-usermenu__trigger__position, relative);
  background-color: var(--haus-usermenu__trigger__background-color, transparent);
  border-radius: var(--haus-usermenu__trigger__border-radius, 50%);
  padding: var(--haus-usermenu__trigger__padding, 0);

  &:hover {
    background: var(--haus-usermenu__trigger__hover__background, transparent);
  }

  &:focus-visible {
    outline: var(--haus-usermenu__trigger__focus-visible__outline, 2px solid currentColor);
    outline-offset: var(--haus-usermenu__trigger__focus-visible__outline-offset, 2px);
  }
}

.loggedInStatus {
  position: var(--haus-usermenu__loggedInStatus__position, absolute);
  right: var(--haus-usermenu__loggedInStatus__right, -1px);
  top: var(--haus-usermenu__loggedInStatus__top, -1px);
  display: var(--haus-usermenu__loggedInStatus__display, flex);
  width: var(--haus-usermenu__loggedInStatus__width, fit-content);
  min-width: var(--haus-usermenu__loggedInStatus__min-width, 12px);
  height: var(--haus-usermenu__loggedInStatus__height, 12px);
  justify-content: var(--haus-usermenu__loggedInStatus__justify-content, center);
  align-items: var(--haus-usermenu__loggedInStatus__align-items, center);
  background-color: var(--haus-usermenu__loggedInStatus__background-color, #43a274);
  padding: var(--haus-usermenu__loggedInStatus__padding, 2px);
  border-radius: var(--haus-usermenu__loggedInStatus__border-radius, 12px);
  animation: pulse 2s 1 none;
}

.dropdownContent {
  background: var(--haus-usermenu__dropdownContent__background, #fff);
  border: var(--haus-usermenu__dropdownContent__border, 1px solid #e5e7eb);
  border-radius: var(--haus-usermenu__dropdownContent__border-radius, 8px);
  padding: var(--haus-usermenu__dropdownContent__padding, 8px 0);
  min-width: var(--haus-usermenu__dropdownContent__min-width, 200px);
  z-index: var(--haus-usermenu__dropdownContent__z-index, 9999);
  box-shadow: var(--haus-usermenu__dropdownContent__box-shadow, 0 8px 24px rgba(0, 0, 0, 0.12));
  overflow: var(--haus-usermenu__dropdownContent__overflow, hidden);
  background-clip: var(--haus-usermenu__dropdownContent__background-clip, padding-box);
}

.menuItemLink {
  display: var(--haus-usermenu__menuItemLink__display, block);
  width: var(--haus-usermenu__menuItemLink__width, 100%);
  padding: var(--haus-usermenu__menuItemLink__padding, 10px 16px);
  color: var(--haus-usermenu__menuItemLink__color, var(--haus-color-body, #111));
  font-family: var(
    --haus-usermenu__menuItemLink__font-family,
    var(--haus-typography-body-font-family, inherit)
  );
  font-size: var(--haus-usermenu__menuItemLink__font-size, 14px);
  text-decoration: var(--haus-usermenu__menuItemLink__text-decoration, none);
  text-align: var(--haus-usermenu__menuItemLink__text-align, start);
  background: var(--haus-usermenu__menuItemLink__background, transparent);
  border: var(--haus-usermenu__menuItemLink__border, none);
  cursor: var(--haus-usermenu__menuItemLink__cursor, pointer);

  &:hover {
    background-color: var(--haus-usermenu__menuItemLink__hover__background-color, #f6f6f6);
    color: var(--haus-usermenu__menuItemLink__hover__color, var(--haus-color-body, #111));
    border-radius: var(--haus-usermenu__menuItemLink__hover__border-radius, 0px);
    border: var(--haus-usermenu__menuItemLink__hover__border, none);
    box-shadow: var(--haus-usermenu__menuItemLink__hover__box-shadow, none);
    cursor: var(--haus-usermenu__menuItemLink__hover__cursor, pointer);
    outline: var(--haus-usermenu__menuItemLink__hover__outline, none);
  }

  &:focus-visible {
    outline: var(--haus-usermenu__menuItemLink__focus__outline, 2px solid currentColor);
    outline-offset: var(--haus-usermenu__menuItemLink__focus__outline-offset, -2px);
  }
}

.logoutItem {
  display: var(--haus-usermenu__logoutItem__display, block);
  width: var(--haus-usermenu__logoutItem__width, 100%);
  padding: var(--haus-usermenu__logoutItem__padding, 10px 16px);
  color: var(--haus-usermenu__logoutItem__color, var(--haus-color-body, #111));
  font-family: var(
    --haus-usermenu__logoutItem__font-family,
    var(--haus-typography-body-font-family, inherit)
  );
  font-size: var(--haus-usermenu__logoutItem__font-size, 14px);
  text-align: var(--haus-usermenu__logoutItem__text-align, start);
  background: var(--haus-usermenu__logoutItem__background, transparent);
  border: var(--haus-usermenu__logoutItem__border, none);
  cursor: var(--haus-usermenu__logoutItem__cursor, pointer);

  &:hover {
    background-color: var(--haus-usermenu__logoutItem__hover__background-color, #f6f6f6);
    border-radius: var(--haus-usermenu__logoutItem__hover__border-radius, 0px);
    border: var(--haus-usermenu__logoutItem__hover__border, none);
    box-shadow: var(--haus-usermenu__logoutItem__hover__box-shadow, none);
    cursor: var(--haus-usermenu__logoutItem__hover__cursor, pointer);
    outline: var(--haus-usermenu__logoutItem__hover__outline, none);
  }

  &:focus-visible {
    outline: var(--haus-usermenu__logoutItem__focus__outline, 2px solid currentColor);
    outline-offset: var(--haus-usermenu__logoutItem__focus__outline-offset, -2px);
  }
}

.divider {
  height: var(--haus-usermenu__divider__height, 1px);
  margin: var(--haus-usermenu__divider__margin, 4px 0);
  background: var(--haus-usermenu__divider__background, #e5e7eb);
}

@keyframes pulse {
  0% {
    transform: var(--haus-usermenu__loggedInStatus__pulse-start-transform, scale(1));
    box-shadow: var(
      --haus-usermenu__loggedInStatus__pulse-start-box-shadow,
      0 0 0 0 rgba(67, 162, 116, 0.6)
    );
  }

  30% {
    transform: var(--haus-usermenu__loggedInStatus__pulse-peak-transform, scale(1.25));
  }

  70% {
    transform: var(--haus-usermenu__loggedInStatus__pulse-dip-transform, scale(0.95));
    box-shadow: var(
      --haus-usermenu__loggedInStatus__pulse-dip-box-shadow,
      0 0 0 8px rgba(67, 162, 116, 0)
    );
  }

  100% {
    transform: var(--haus-usermenu__loggedInStatus__pulse-end-transform, scale(1));
    box-shadow: var(
      --haus-usermenu__loggedInStatus__pulse-end-box-shadow,
      0 0 0 0 rgba(67, 162, 116, 0)
    );
  }
}
